/* eslint-disable react-native/no-inline-styles */
import React, { useState } from "react"
import { View, Text, TouchableOpacity, Image, ScrollView } from "react-native"
import { Button, CustomHeader, Screen } from "components"
import { style } from "./styles"
import { useNavigation } from "@react-navigation/native"
import { translate } from "i18n"
import LinearGradient from "react-native-linear-gradient"
import image1 from "../../../../assets/images/download.png"
import image2 from "../../../../assets/images/download(1).png"
import { colors } from "colors"
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons"
import { useColor } from "app/theme/getThemes"

export const RewardGift = () => {
  const navigation = useNavigation()
  const { companyTheme } = useColor()

  const [reward, setRewards] = useState([
    {
      totalRewards: 5,
      receivedReward: 5,
      rewardTitle: "Invite 5 Friends to Join Us!",
      img: image1,
      status: "active",
      rewards: "Get a free drinks",
    },
    {
      totalRewards: 10,
      receivedReward: 5,
      rewardTitle: "Invite 10 Friends to Join Us!",
      img: image2,
      status: "active",
      rewards: "Free a set meal including drinks",
    },
  ])

  return (
    <>
      <CustomHeader headerTitle={"Friends Rewards"} />
      <Screen>
        <ScrollView
          style={style.detailsContainer}
          contentContainerStyle={{ paddingBottom: 50 }}
          showsVerticalScrollIndicator={false}
        >
          <Text style={[style.tierTitle, { color: companyTheme.first }]}>Invite for Rewards!</Text>
          <Text style={style.benefitText}>Grab more friend to claims rewards!</Text>

          {reward.map((item, index) => (
            <TouchableOpacity key={index}>
              <LinearGradient
                style={[style.tierContentContainer, { paddingRight: 0 }]}
                colors={[companyTheme.first, companyTheme.second]}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
              >
                <View style={[style.row, { display: "flex", justifyContent: "space-around" }]}>
                  <View style={[style.ml20, { width: "70%" }]}>
                    <Text style={style.tierSpendText}>{item?.rewardTitle}</Text>
                    <View style={{ flexDirection: "row", flexWrap: "wrap", marginVertical: 10 }}>
                      {Array.from({ length: item.totalRewards })
                        .reduce((rows: any, _, index) => {
                          if (index % 5 === 0) rows?.push([])
                          rows[rows?.length - 1].push(index)
                          return rows
                        }, [])
                        .map((row, rowIndex) => (
                          <View key={rowIndex} style={{ flexDirection: "row", marginBottom: 10 }}>
                            {row.map((index) => (
                              <View
                                key={index}
                                style={{
                                  backgroundColor: "#D3D3D3",
                                  width: 30,
                                  height: 30,
                                  marginRight: 10,

                                  borderRadius: 15, // 50% of width/height for a perfect circle
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderWidth: 1,
                                  borderColor: index < item.receivedReward ? "#FFD700" : "black",
                                  borderStyle: "dashed",
                                  position: "relative", // For positioning sparkle icons
                                }}
                              >
                                {index < item.receivedReward ? (
                                  <LinearGradient
                                    colors={["#FFFACD", "#FFD700", "#FFC107"]}
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      right: 0,
                                      bottom: 0,
                                      borderRadius: 15,
                                    }}
                                  />
                                ) : (
                                  <View
                                    style={{
                                      backgroundColor: "#fefef4",
                                      position: "absolute",
                                      borderRadius: 15,
                                    }}
                                  />
                                )}
                                <Text
                                  style={[
                                    style.tierSpendText,
                                    { color: "#000", zIndex: 998, marginTop: 0 },
                                  ]}
                                >
                                  {index + 1}
                                </Text>
                                {index < item.receivedReward && (
                                  <>
                                    <MaterialCommunityIcons
                                      name="star-four-points"
                                      size={8}
                                      color="#FFFFE0"
                                      style={{ position: "absolute", top: 3, left: 3 }}
                                    />
                                    <MaterialCommunityIcons
                                      name="star-four-points"
                                      size={6}
                                      color="#FFFACD"
                                      style={{ position: "absolute", bottom: 5, right: 5 }}
                                    />
                                  </>
                                )}
                              </View>
                            ))}
                          </View>
                        ))}
                    </View>
                    <Text style={[style.tierSpendText, { flex: 1 }]}>{item?.rewards}</Text>
                    {item?.receivedReward === item?.totalRewards ? (
                      <Button
                        style={[
                          style.mt10,
                          {
                            paddingTop: "3%",
                            backgroundColor: "white",
                            color: "red",
                          },
                        ]}
                        title="Redeem"
                      />
                    ) : null}
                  </View>

                  <View style={{ width: "20%" }}>
                    <Image
                      source={{
                        uri: item?.img,
                      }}
                      resizeMode="cover"
                      style={{
                        width: 70,
                        height: 70,
                        alignSelf: "flex-end",
                        marginLeft: 20,
                        backgroundColor: "transparent",
                      }}
                    />
                  </View>
                </View>
              </LinearGradient>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </Screen>
    </>
  )
}
